import React from "react"

export const CJAwsAccess = ({features}) => {
    return <cj-aws-access features={features}/>
}